import Swiper from 'swiper/bundle';

export default function swiperCasesSucesso() {

    const containerSwiper1 = document.querySelector('.mySwiper1');
    const containerSwiper2 = document.querySelector('.mySwiper2');

    if (!containerSwiper1 && !containerSwiper2) return;

    const config = {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true, 
        autoplay: {
            delay: 2500,              
            disableOnInteraction: false, 
            pauseOnMouseEnter: true,    
        },
        speed: 600,
        breakpoints: {
            640: { 
                slidesPerView: 3, 
                spaceBetween: 30 
            },
            1024: { 
                slidesPerView: 5, 
                spaceBetween: 40 
            },
        }
    };

    if (containerSwiper1) {
        new Swiper(".mySwiper1", {
            ...config,
            navigation: {
                nextEl: ".swiper-button-next-1",
                prevEl: ".swiper-button-prev-1",
            },
        });
    }

    if (containerSwiper2) {
        new Swiper(".mySwiper2", {
            ...config,
            navigation: {
                nextEl: ".swiper-button-next-2",
                prevEl: ".swiper-button-prev-2",
            },
        });
    }
}
